module.exports = __webpack_public_path__ + "static/media/20ECE18.79c5615a.jpg";